import { render, staticRenderFns } from "./IssueCreate.vue?vue&type=template&id=b1c85b58&scoped=true&"
import script from "./IssueCreate.vue?vue&type=script&lang=js&"
export * from "./IssueCreate.vue?vue&type=script&lang=js&"
import style0 from "./IssueCreate.vue?vue&type=style&index=0&id=b1c85b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c85b58",
  null
  
)

export default component.exports